<template>
    <div>
            <!-- Titulo -->
            <h3 class="mt-1 mb-2 " v-text="titulo"></h3>

            <!--Filtro -->
            <b-card class="my-3">
                <b-row  align-self="start">
                    <b-col class="col-md-2">
                        <b-form-group
                            label="Edição"
                            label-size="sm"
                        >
                            <b-form-input
                                id="edicao"
                                v-model="filtro.numero_edicao"
                                @keypress="$helper.somenteNumeros"
                            >
                            </b-form-input>
                        </b-form-group>
                    </b-col>
                </b-row>

                <b>Período de publicação</b>
                <b-row align-self="start">
                    <b-col class="col-md-3">
                        <b-form-group
                            label="Data início"
                            label-size="sm">

                            <b-form-input
                                id="data_inicio"
                                type="date"
                                v-model="filtro.data_inicio"
                                :state="validateDataInicio"
                                aria-describedby="feedback_data_inicio"
                                max="2999-12-31">
                            </b-form-input>
                            <b-form-invalid-feedback id="feedback_data_inicio">Formato válido (dd/mm/yyyy).</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                    <b-col class="col-md-3">
                        <b-form-group
                            label="Data fim"
                            label-size="sm"
                        >
                            <b-form-input
                                id="data_fim"
                                type="date"
                                v-model="filtro.data_fim"
                                :state="validateDataFim"
                                aria-describedby="feedback_data_fim"
                                max="2999-12-31">
                            </b-form-input>
                            <b-form-invalid-feedback id="feedback_data_fim">Formato válido (dd/mm/yyyy).</b-form-invalid-feedback>
                        </b-form-group>
                    </b-col>
                </b-row>
                <b-row>
                    <b-col class="text-right">
                        <b-btn class="col-sm-12 col-md-auto" variant="primary" @click="listar" >
                            <i class="fa fa-search pr-1"></i> Pesquisar
                        </b-btn>
                    </b-col>
                </b-row>
            </b-card>


            <!-- Tabela -->
            <b-card >
                <alert
                    :variant="alert.variant"
                    dismissible
                    :mensagens="alert.mensagens"
                    :value="alert.exibir"
                    @input="alertDismissed">
                </alert>

                <b-row class="mb-2">
                    <b-col class="text-right">
                        <b-btn class="col-sm-12 col-md-auto" variant="outline-secondary" @click="incluir"  >
                            <i class="fa fa-file-o pr-1"></i> Nova Edição
                        </b-btn>
                    </b-col>
                </b-row>

                <b-row class="mx-0">
                    <b-table
                        no-provider-paging
                        small
                        responsive
                        :current-page="tabela.currentPage"
                        :empty-text="tabela.emptyText"
                        :fields="tabela.fields"
                        :items="tabela.items"
                        :per-page="tabela.perPage"
                        :show-empty="tabela.showEmpty"
                        :striped="tabela.striped">

                        <template v-slot:cell(tipo_edicao)="data" >
                            {{$helper.getTipoEdicao(data.value)}}
                        </template>

                        <template v-slot:cell(dt_publicacao)="data" >
                            {{$helper.formatData(data.value)}}
                        </template>

                        <template v-slot:cell(hr_publicacao)="data" >
                            {{$helper.formatHoraMinuto(data.value)}}
                        </template>

                        <template v-slot:cell(documento_jornal)="data" >
                            <i v-if="data.value.nome_minio" class="fa fa-newspaper-o" @click="abrirDocumentoJornal(data.value)"></i>
                        </template>

                        <template v-slot:cell(ato)="data" >
                            <i class="fa fa-files-o" @click="irParaAbaAtos(data.item)"></i>
                        </template>

                        <template v-slot:cell(documento_capa)="data" >
                            <i v-if="data.value.nome_minio" class="fa fa-file-image-o" @click="$helper.exibirDocumento($env.VUE_APP_URL_API, data.value.nome_minio, data.value.prefix)"></i>
                        </template>

                        <template v-slot:cell(ver)="data" >
                            <i class="fa fa-eye fa-lg" @click="visualizar(data.item)"></i>
                        </template>

                        <template v-slot:cell(editar)="data" >
                            <i class="fa fa-pencil fa-lg" @click="editar(data.item)" ></i>
                        </template>

                        <template v-slot:cell(excluir)="data" >
                            <i class="fa fa-trash fa-lg" @click="excluir(data.item)" v-if="$helper.verificaDataEdicaoMaiorAtual(data.item)"></i>
                        </template>

                    </b-table>
                </b-row>
                <b-row align-h="end">
                    <b-col class="col-md-3">
                        <b-form-group
                            label-cols="8"
                            label="Itens por página:"
                            label-align="right"
                            label-size="sm"
                            label-class="mt-1 text-secondary"
                        >
                            <b-form-select
                                v-model="tabela.perPage"
                                size="sm"
                                :options="tabela.pageOptions"
                                @change="tabela.currentPage=1"
                                >
                            </b-form-select>
                        </b-form-group>
                    </b-col>
                    <b-col cols="3">
                        <b-pagination v-show="tabela.totalRows > tabela.perPage" align="right"
                            :total-rows="tabela.totalRows"
                            :per-page="tabela.perPage"
                            :value="tabela.currentPage"
                            @change="mudaPagina"
                            class="mt-2"
                            size="sm"
                        >
                        </b-pagination>
                    </b-col>
                </b-row>
            </b-card>
    </div>
</template>

<script>

import moment from 'moment'
import Edicao from '../../../models/Edicao'
import Alert from '../../../models/Alert'

export default {

    data(){
        return {

            titulo: 'Edições',

            filtro: {
                numero_edicao: '',
                data_inicio: moment().format('YYYY-MM-01'),
                data_fim: moment().add(1,'days').format('YYYY-MM-DD'),
            },

            tabela:{
                currentPage: 1,
                items: [],
                emptyText:'Nenhum registro encontrado',
                fields: [
                    {
                        key: 'numero_edicao',
                        label: 'Edição',
                        sortable: true,
                        class: 'text-center'
                    },
                    {
                        key: 'tipo_edicao',
                        label: 'Tipo Edição',
                        sortable: true,
                        class: 'text-center'
                    },
                    {
                        key: 'dt_publicacao',
                        label: 'Data da Publicação',
                        sortable: true,
                        class: 'text-center',
                    },
                    {
                        key: 'hr_publicacao',
                        label: 'Hora Publicação',
                        class: 'text-center'
                    },
                    {
                        key: 'documento_jornal',
                        label: 'DOM Completo',
                        class: 'text-center'
                    },
                    {
                        key: 'ato',
                        label: 'Atos',
                        class: 'text-center'
                    },
                    {
                        key: 'documento_capa',
                        label: 'Capa',
                        class: 'text-center'
                    },
                    {
                        key: 'ver',
                        label: '',
                        class: 'text-center'
                    },
                    {
                        key: 'editar',
                        label: '',
                        class: 'text-center'
                    },
                                        {
                        key: 'excluir',
                        label: '',
                        class: 'text-center'
                    },

                ],
                perPage: 10,
                showEmpty: true,
                striped: true,
                totalRows: 0,
                pageOptions: [10, 25, 50],
            },
            alert: new Alert()

        }
    },

    computed: {
        validateDataInicio() {
            return this.$helper.regExpDate.test(this.filtro.data_inicio) ? null : false;
        },
        validateDataFim() {
            return this.$helper.regExpDate.test(this.filtro.data_fim) ? null : false;
        },
    },

    methods: {

        alertDismissed(){
            this.alert = new Alert()
        },

        incluir(){
            this.$router.push({ name: 'edicaoTabs', params: {id:'new'} });
        },

        visualizar(edicao){
            this.$router.push({ name: 'edicaoTabsView', params: { id:edicao.id} });
        },

        editar(edicao){
            this.$router.push({ name: 'edicaoTabs', params: { id:edicao.id } });
        },

        excluir(edicao){
            let tipoEdicao = this.$helper.getTipoEdicao(edicao.tipo_edicao);
            let message = `Confirma a exclusão da Edição
                            ${edicao.numero_edicao} - ${tipoEdicao}
                            de ${moment(edicao.dt_publicacao).format('DD/MM/YYYY')} - ${edicao.hr_publicacao}?`;
            this.$helper.confirmaExclusao(this, message)
                .then(confirmado => {
                    if(confirmado){
                        this.$api.edicao.excluir(edicao.id)
                            .then(response => {
                                if(response.status == 200 || response.status == 201){
                                    this.listar();
                                    this.$helper.showAlert(this.alert,
                                                           this.$constantes.alert.variants.SUCCESS,
                                                           'Registro excluído com sucesso!');
                                }
                            })
                            .catch(error => {
                                this.$helper.showAlert(this.alert,
                                                       this.$constantes.alert.variants.DANGER,
                                                       error.response.data.errors);
                            });

                        this.$helper.scrollWindowToTop();
                    }
                });
        },

        irParaAbaAtos(edicao){
            this.$router.push({ name: 'edicaoTabs', params: { id:edicao.id, tabSelecionada: 1} });
        },

        listar(){

            const inicio = new Date(this.filtro.data_inicio);
            const fim    = new Date(this.filtro.data_fim);

            if(fim.getTime() < inicio.getTime()) {
                this.$helper.showAlert(this.alert,
                                       this.$constantes.alert.variants.DANGER,
                                       'Data fim deve ser maior que a Data início!');
                return;
            }

            var params = {};
            params.numero_edicao = this.filtro.numero_edicao;
            params.data_inicio = moment(this.filtro.data_inicio + " " + "00:00").format('YYYY-MM-DD HH:mm');
            params.data_fim = moment(this.filtro.data_fim + " " + "23:59").format('YYYY-MM-DD HH:mm');

            this.$api.edicao.listar(params)
                .then(response => {
                    this.tabela.items = [];
                    response.data.data.forEach(element => {
                        let edicao = new Edicao(element);
                        this.tabela.items.push(edicao);
                    });
                    this.tabela.totalRows = response.data.data.length;
                    this.mudaPagina(1);
                })
                .catch(error => {
                   this.$helper.showAlert(this.alert,
                                          this.$constantes.alert.variants.DANGER,
                                          error.response.data.errors);
                });
        },

        mudaPagina(pagina) {
            this.tabela.currentPage = pagina;
        },

        abrirDocumentoJornal(documentoJornal){
            //Para documentos grandes abre a janela de download ao inves de visualizacao
            if(documentoJornal.size > this.$constantes.documentos.TAMANHO_LIMITE_PARA_VISUALIZACAO){
                let url = `${this.$env.VUE_APP_URL_API}/api/v1/documentos/${documentoJornal.nome_minio}/download`;
                if(documentoJornal.prefix){
                    url +=`?prefix=${documentoJornal.prefix}`;
                }
                window.location.assign(url);
            }else{
                this.$helper.exibirDocumento(this.$env.VUE_APP_URL_API, documentoJornal.nome_minio, documentoJornal.prefix);
            }
        },

    },

    mounted(){
        this.listar();
    },

}
</script>

<style>
    .cursor-pointer {
        cursor: pointer;
    }
</style>

